<template>
  <div class="wrapper">
    <div class="contents">
      <router-view />
    </div>
  </div>
</template>

<script>
// import { mapState, mapActions } from 'vuex';
import {
// GlobalHeader,
// GlobalFooter,
} from '@/components/layouts';

export default {
  name: 'App',
  components: {
    // GlobalHeader,
    // GlobalFooter,
  },
  computed: {
  },
  created() {
    // ログインチェック
    this.$store.dispatch('user/login/check');
    // backend共通マスターデータ取得
    this.$store.dispatch('helper/getMaster');
  },
  watch: {
  },
  methods: {
  },
};
</script>


<style lang="scss">
</style>
